import { HIDE_REWARD_CLAIM_SECTION } from "utils/Config";

export const getInboxUnreadCount = (messageUnreadCount) => {
  if (messageUnreadCount > 99) {
    return ' (99+)';
  }
  if (messageUnreadCount <= 0) {
    return '';
  }
  return ` (${messageUnreadCount})`;
};

export const unloginCommonNavItemList = [
  {
    name: "home_home",
    linkTo: "/home",
    imageUrl: '/menu/home.png',
    srcSet: '/menu/home@2x.png 2x, /menu/home@3x.png 3x',
  },
  {
    name: "home_offers",
    linkTo: "/offer/LATEST",
    imageUrl: '/menu/offer.png',
    srcSet: '/menu/offer@2x.png 2x, /menu/offer@3x.png 3x',
  },
  {
    name: "about_upper",
    linkTo: "/about",
    imageUrl: '/menu/about.png',
    srcSet: '/menu/about@2x.png 2x, /menu/about@3x.png 3x',
  },
  {
    name: 'home_family_booking',
    imageUrl: '/menu/familyBooking.png',
    linkTo: '/family_booking',
    srcSet: '/menu/familyBooking@2x.png 2x, /menu/familyBooking@3x.png 3x',
  }
];

export const loginCommonNavItemList = [
  {
    name: "home_home",
    linkTo: "/home",
    imageUrl: '/menu/home.png',
    srcSet: '/menu/home@2x.png 2x, /menu/home@3x.png 3x',
  },
  {
    name: "home_offers",
    linkTo: "/offer/LATEST",
    imageUrl: '/menu/offer.png',
    srcSet: '/menu/offer@2x.png 2x, /menu/offer@3x.png 3x',
  },
  ...(
    HIDE_REWARD_CLAIM_SECTION
    ? []
    : [
      {
        name: "points_claim",
        linkTo: "/transaction",
        imageUrl: '/menu/cart.png',
        srcSet: '/menu/cart@2x.png 2x, /menu/cart@3x.png 3x',
      },
    ]
  ),
  {
    name: "about_upper",
    linkTo: "/about",
    imageUrl: '/menu/about.png',
    srcSet: '/menu/about@2x.png 2x, /menu/about@3x.png 3x',
  },
  {
    name: 'home_family_booking',
    imageUrl: '/menu/familyBooking.png',
    linkTo: '/family_booking',
    srcSet: '/menu/familyBooking@2x.png 2x, /menu/familyBooking@3x.png 3x',
  },
  {
    name: "home_inbox",
    linkTo: "/inbox",
    imageUrl: '/menu/inbox.png',
    srcSet: '/menu/inbox@2x.png 2x, /menu/inbox@3x.png 3x',
  },
];

export const profileNavItemList = [
  {
    name: 'my_profile',
    linkTo: '/user/myProfile',
    imageUrl: '/menu/myProfile.png',
    srcSet: '/menu/myProfile@2x.png 2x, /menu/myProfile@3x.png 3x',
  },
  {
    name: 'my_card',
    linkTo: '/user/myCard',
    imageUrl: '/menu/myCard.png',
    srcSet: '/menu/myCard@2x.png 2x, /menu/myCard@3x.png 3x',
  },
  {
    name: 'profile_my_coupons',
    linkTo: '/user/myCoupon',
    imageUrl: '/menu/myCoupons.png',
    srcSet: '/menu/myCoupons@2x.png 2x, /menu/myCoupons@3x.png 3x',
  },
  // {
  //   name: 'myTicket',
  //   linkTo: '/user/myTicket',
  //   imageUrl: '/menu/myCoupons.png',
  //   srcSet: '/menu/myCoupons@2x.png 2x, /menu/myCoupons@3x.png 3x',
  // },
  {
    name: 'profile_my_account',
    linkTo: '/user/myAccount',
    imageUrl: '/menu/myAccount.png',
    srcSet: '/menu/myAccount@2x.png 2x, /menu/myAccount@3x.png 3x',
  },
];
